var $fcda0e0582088650$exports = {};
$fcda0e0582088650$exports = {
  "help": `\u{17D}inynas`,
  "info": `Informacija`
};
export { $fcda0e0582088650$exports as default };